import React from 'react';
import {
    Badge,
    Box,
    HStack,
    SimpleGrid,
    Stat,
    StatHelpText,
    StatLabel,
    StatNumber,
    Text,
    VStack,
} from '@chakra-ui/react';

function WorkspaceHero({
    title,
    description,
    eyebrow,
    stats = [],
    actions,
    bg = 'white',
    borderColor = 'gray.200',
    titleColor = 'gray.800',
    descriptionColor = 'gray.600',
    accentColor = 'brand.navy',
    cardBg = 'white',
}) {
    return (
        <Box
            bg={bg}
            borderWidth="1px"
            borderColor={borderColor}
            borderRadius="2xl"
            boxShadow="md"
            px={{ base: 5, md: 8 }}
            py={{ base: 5, md: 7 }}
        >
            <VStack align="stretch" spacing={6}>
                <HStack justify="space-between" align="start" flexWrap="wrap" spacing={4}>
                    <Box maxW="4xl">
                        {eyebrow ? (
                            <Badge
                                colorScheme="blue"
                                borderRadius="full"
                                px={3}
                                py={1}
                                mb={3}
                                fontSize="0.72rem"
                                textTransform="uppercase"
                                letterSpacing="0.08em"
                            >
                                {eyebrow}
                            </Badge>
                        ) : null}
                        <Text
                            as="h1"
                            fontSize={{ base: '2xl', md: '3xl' }}
                            fontWeight="bold"
                            color={titleColor}
                            lineHeight="shorter"
                        >
                            {title}
                        </Text>
                        <Text mt={3} color={descriptionColor} fontSize={{ base: 'sm', md: 'md' }} maxW="3xl">
                            {description}
                        </Text>
                    </Box>
                    {actions ? (
                        <Box>{actions}</Box>
                    ) : null}
                </HStack>

                {stats.length > 0 ? (
                    <SimpleGrid columns={{ base: 1, md: Math.min(stats.length, 3) }} spacing={4}>
                        {stats.map((stat) => (
                            <Stat
                                key={stat.label}
                                bg={cardBg}
                                borderWidth="1px"
                                borderColor={borderColor}
                                borderRadius="xl"
                                px={4}
                                py={4}
                            >
                                <StatLabel color={descriptionColor}>{stat.label}</StatLabel>
                                <StatNumber color={accentColor} fontSize={{ base: 'xl', md: '2xl' }}>
                                    {stat.value}
                                </StatNumber>
                                {stat.help ? (
                                    <StatHelpText color={descriptionColor} mb={0}>
                                        {stat.help}
                                    </StatHelpText>
                                ) : null}
                            </Stat>
                        ))}
                    </SimpleGrid>
                ) : null}
            </VStack>
        </Box>
    );
}

export default WorkspaceHero;
